module.exports = __webpack_public_path__ + "static/media/cancel.65c6c538.svg";